import type { Definition } from '../../../schema/frameworks/entry.js';
import type { EventType, SportType } from '../../../schema/sport/entry.js';

/**
 * Function to determine the amount of outcomes for a specific event based on product, sport type and event type.
 *
 * @param sportType Sport type entity
 * @param eventType Event type entity
 * @param definition The definition for the product
 * @returns Count for the amount of outcomes
 */
export function getOutcomeCount(sportType: SportType, eventType: EventType, definition: Definition): number {
  // TODO: [CA]: this should be moved to a use case that can utilize draw service and IDefinitionEntity
  // Replace sportType and eventType with EventNumber + DrawNumber instead to lookup what event count we should use
  if (definition.outcomes.outcomeHeatmap) {
    const heatMap = definition.outcomes.outcomeHeatmap[sportType];
    return heatMap.maxValue - heatMap.minValue + 1;
  }

  if (eventType === 'OVER_UNDER') {
    return 2;
  }

  return definition.outcomes.outcomeCount;
}
